<template>
    <div class="modal fade" id="getAccessModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-dialog--access">
            <div class="modal-content modal-content--access">
                <div class="container">
                    <div class="modal-box">
                        <button
                            type="button"
                            class="modal-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <svg width="24" height="24">
                                <use
                                    href="/static/images/sprite/sprite.svg#close"
                                ></use>
                            </svg>
                        </button>
                        <div class="modal-inner">
                            <div class="modal-header">
                                <h2 class="modal-title">{{ title }}</h2>
                            </div>
                            <div class="modal-body">
                                <p v-html="text"></p>
                            </div>
                            <div class="modal-footer">
                                <a :href="$getSubdomainLink('payment', '/sign-up')" class="btn btn-secondary">
                                  Log in
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalAccess",
    props: {
        title: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
    },
};
</script>
